'use client';

import styles from './policy.module.css';
import Head from "next/head";

export default function CookiePolicyPage() {
  
  return (
    

      <div className={styles.pageWrapper}>
        <h1 className={styles.title}>Cookie Policy</h1>
        <p className={styles.updated}>Last updated: October 2025</p>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>1. What Are Cookies?</h2>
          <p className={styles.sectionText}>
            Cookies are small text files stored on your device. They allow us to provide a consistent,
            secure, and personalized user experience across our services.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>2. How We Use Cookies</h2>
          <p className={styles.sectionText}>
            We use only essential cookies required for the operation of Mira Classic. These cookies
            include technical data used to provide personalized recommendations, maintain secure
            sessions, and ensure that the service functions as intended.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>3. Essential Cookies</h2>
          <p className={styles.sectionText}>
            Essential cookies are strictly necessary for login, session persistence, and personalized
            recommendations. Without these cookies, the service cannot provide tailored suggestions
            or maintain secure access to your account.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>4. Third‑Party Services</h2>
          <p className={styles.sectionText}>
            We may rely on trusted third‑party providers (such as email delivery services or payment
            gateways) that set their own essential cookies to ensure secure transactions and reliable
            communication. These providers have their own cookie policies, which we encourage you to
            review.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>5. Managing Cookies</h2>
          <p className={styles.sectionText}>
            You can disable or delete cookies in your browser settings. Please note that disabling
            essential cookies may prevent you from signing in, using recommendations, or accessing
            core features of Mira Classic.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>6. Consent</h2>
          <p className={styles.sectionText}>
            By continuing to use our services, you consent to the use of essential cookies as described
            in this policy. Because these cookies are strictly necessary for the service to function,
            they cannot be disabled through the cookie banner.
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>7. Updates to This Policy</h2>
          <p className={styles.sectionText}>
            We may update this Cookie Policy from time to time to reflect changes in technology,
            legal requirements, or our services. The &quot;Last updated&quot; date will always indicate the
            latest revision.
          </p>
        </div>
      </div>
    
  );
}
